import React from 'react'
import Button from '../elements/Button'
import NoticesHOC from '../modules/NoticesHOC'
import { withRouter } from 'react-router-dom'

const NoticeInterimPayment = (props) => {
    const handleClick = event => {
        event.preventDefault()
        props.hideNotice()
        props.history.push(`/my-services/mobile/${props.data.serviceId}/interim-payment`)
    }

    return (
        <div className='row text-center'>
            <div className='col-12 col-lg-10 offset-lg-1'>
                <h2>Your mobile service has reached it's maximum spend limit</h2>
                <p className='lh'>This means your service may be limited, or blocked to prevent further spending.</p>
                <p className='lh'>If you would like to reset the limit back to $0 to continue using your service you can make an interim payment of <span className='bold'>${props.data.interimAmount}</span> now, otherwise your service will reset automatically on {props.data.nextBillingCycleStart}.</p>
                <Button title='Make interim payment now' action={handleClick} />
            </div>
        </div>
    )
}

export default withRouter(NoticesHOC(NoticeInterimPayment))



// WEBPACK FOOTER //
// ./resources/js/components/NoticeInterimPayment.js